/**
 * MSES is English only, like OVR (decided by the user 2026-10-22): one locale,
 * `locales/en/*.json` behind typed `t()` keys, no picker. The medal desk is a
 * handful of host staff; GMS (apps/gms) is the app that keeps all ten.
 */

export const SUPPORTED_LOCALES = ["en"] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";

/** The locale handed to Intl.DateTimeFormat / Intl.NumberFormat. */
export function intlLocaleFor(_locale: string): string {
	return DEFAULT_LOCALE;
}
